import { defineStore } from 'pinia';
import { computed, ref } from '@nuxtjs/composition-api';

export const useCartStore = defineStore('tlmCart', () => {
  const theCart = ref({})
  const cprNumber = ref({})
  const cvrNumber = ref({})
  const isProtectedAddress = ref(false)
  const paymentRef = ref('')
  const actionResponse = ref({})
  const cartScenarios = ref({})

  const getCart = computed(() => theCart.value)
  function setCart(cart) {
    theCart.value = cart;
  }

  return {
    cartScenarios,
    setCart,
    getCart,
    cprNumber,
    cvrNumber,
    isProtectedAddress,
    paymentRef,
    actionResponse
  }
})
